import React from 'react'
import { Widget } from "@digital/ui";
import { Col, Collapse, Icon, Row, Steps } from "antd";
import WidgetSumario from "./WidgetSumario";

const AbaSumario = () => {
    return (
        <Row>
            <Col>
                <WidgetSumario />
            </Col>
        </Row>
    )
}

export default AbaSumario